import {ActionItem, ActionItemStyle, EllipsisMultiActionItem, OpenDirection} from '@stylehaven/components';
import {MAX_ITEMS_IN_ACTION_BAR} from '../constants';

export const ReduceVisibleActionItems = (
    actionItemsOrNulls: (ActionItem | null)[],
    actionItemStyle: ActionItemStyle = ActionItemStyle.PureSquareIconButtonLight,
    direction: OpenDirection = OpenDirection.AboveLeft
): ActionItem[] => {
    const actionItems: ActionItem[] = actionItemsOrNulls.filter((actionItem): actionItem is ActionItem => !!actionItem);
    const shouldOverflow: boolean = MAX_ITEMS_IN_ACTION_BAR >= 0 && actionItems.length > MAX_ITEMS_IN_ACTION_BAR;

    if (shouldOverflow) {
        const allActions: ActionItem[] = [...actionItems];
        allActions.sort((firstElement, secondElement) => sortByEnabledState(firstElement, secondElement));

        const visibleItems: ActionItem[] = allActions.slice(0, MAX_ITEMS_IN_ACTION_BAR);
        const invisibleItems: ActionItem[] = allActions.slice(MAX_ITEMS_IN_ACTION_BAR);
        const ellipsis: ActionItem = EllipsisMultiActionItem(
            unpackActionItems(invisibleItems),
            false,
            actionItemStyle,
            direction
        );

        return [...visibleItems, ellipsis];
    } else {
        return actionItems;
    }
};

function unpackActionItems(actionItems: ActionItem[]): ActionItem[] {
    return actionItems.flatMap(actionItem => {
        if (actionItem.actionItems) {
            return unpackActionItems(actionItem.actionItems);
        } else {
            return [actionItem];
        }
    });
}

function sortByEnabledState(firstElement: ActionItem, secondElement: ActionItem): number {
    const firstElementIsEnabled = !firstElement.disabled;
    const secondElementIsEnabled = !secondElement.disabled;

    if (firstElementIsEnabled && !secondElementIsEnabled) {
        return -1;
    }

    if (!firstElementIsEnabled && secondElementIsEnabled) {
        return 1;
    }

    return 0;
}
